module.exports = __webpack_public_path__ + "static/assets/5a70df361bb00fa62b9338d89c92f377.png";